import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FC46F7BD-E8E2-452C-868C-E168E13B278D
 * name subdirectory-arrow-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subdirectory-arrow-left.svg
 * tags
 * - Arrow 
 */
export const SubdirectoryArrowLeftIcon = createSvgIcon(<><path d="M11,9L12.42,10.42L8.83,14H18V4H20V16H8.83L12.42,19.58L11,21L5,15L11,9Z" /></>, 'SubdirectoryArrowLeftIcon');
export default SubdirectoryArrowLeftIcon